import { hc } from "hono/client";

//#region src/index.ts
const createBlobClient = ({ token, baseUrl }) => hc(baseUrl ?? "https://blob-store.locuslabs.com/prod", { headers: { "x-api-key": token } });
function createBlobHelper(opts) {
	const client = createBlobClient(opts);
	return {
		client,
		getBlob: async (blobId, options) => {
			const res = await client.v1[":id"].$get({
				param: { id: blobId },
				query: {
					folder: options?.folder,
					bucket: options?.bucket,
					redirect: options?.redirect === false ? "false" : "true"
				}
			});
			const body = await res.json();
			return {
				ok: res.ok,
				body
			};
		},
		putBlob: async (options, data) => {
			const json = await (await client.v1.$get({
				query: {
					folder: options.folder,
					bucket: options.bucket
				},
				header: { Type: options.type }
			})).json();
			const uploadBody = typeof data === "string" ? data : JSON.stringify(data);
			await fetch(json.url, {
				method: "PUT",
				body: uploadBody,
				headers: { "Content-Type": options.type }
			});
			return {
				ok: true,
				body: json
			};
		}
	};
}

//#endregion
export { createBlobClient, createBlobHelper };
//# sourceMappingURL=index.mjs.map